import { LiturgyItem } from "./types";
export const getLesserLitany = () => {
    const result: LiturgyItem[] = [];

    result.push({
        type: "chant",
        boldMode: "none",
        rubric: "Officiant:",
        tone: "2.1",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Lord",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "have",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "mer",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "cy",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "up",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "on",
                                    notes: ["5", "4"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: ["5"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    result.push({
        type: "chant",
        boldMode: "all",
        tone: "2.1",
        rubric: "People:",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Christ",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "have",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "mer",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "cy",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "up",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "on",
                                    notes: ["5", "4"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: ["5"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    result.push({
        type: "chant",
        boldMode: "all",
        tone: "2.1",
        rubric: "All:",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Lord",
                                    notes: ["3"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "have",
                                    notes: ["3"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "mer",
                                    notes: ["3"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "cy",
                                    notes: ["3"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "up",
                                    notes: ["3"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "on",
                                    notes: ["3", "2"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: ["3"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    return result;
};
